const projectCode = process.env.REACT_APP_PROJECT_CODE;
const cityCode = process.env.REACT_APP_CITY_CODE;

export const getConfig = () => {
  switch (projectCode) {
    case "CK":
      return CK_CONFIG;
    case "E4F":
      return E4F_CONFIG;
    case "DEMO":
      return DEMO_CONFIG;
    case "MEELZ":
      return MEELZ_CONFIG;
    default:
      return CK_CONFIG;
  }
};

export const CK_CONFIG = {
  projectCode,
  logo: "/images/logo.svg",
  title: "GWT",
  cityCode,
  currency: "GEL"
};

export const E4F_CONFIG = {
  projectCode,
  logo: "/images/e4f/logo-gwt-e4f.png",
  title: "E4F",
  cityCode,
  currency: "GEL"
};

export const DEMO_CONFIG = {
  projectCode,
  logo: "/images/demo/demo-logo-admin.png",
  title: "DEMO",
  cityCode,
  currency: "GEL"
};

export const MEELZ_CONFIG = {
  projectCode,
  logo: "/images/meelz/logo-gwt-meelz.png",
  title: "MEELZ",
  cityCode,
  currency: "AED"
};

export const DEFAULT_IMAGE = '/images/photoForGoFit.jpg';

// Admin defaults match the actual current project styles:
// sidebar/header = white, page bg = #f8f8f8, AntD blue primary
const BRAND_ADMIN_COLORS = {
  CK:    { primary: "#1677ff", background: "#f8f8f8", header: "#ffffff", button: "#1677ff", text: "#141414" },
  E4F:   { primary: "#1677ff", background: "#f8f8f8", header: "#ffffff", button: "#1677ff", text: "#141414" },
  MEELZ: { primary: "#1677ff", background: "#f8f8f8", header: "#ffffff", button: "#1677ff", text: "#141414" },
  DEMO:  { primary: "#1677ff", background: "#f8f8f8", header: "#ffffff", button: "#1677ff", text: "#141414" },
};

const BRAND_CLIENT_COLORS = {
  CK:    { primary: "#ff6b35", secondary: "#2ecc71", background: "#ffffff", header: "#1a1a2e", footer: "#1a1a2e", button: "#ff6b35", text: "#333333" },
  E4F:   { primary: "#27ae60", secondary: "#f39c12", background: "#ffffff", header: "#1a472a", footer: "#1a472a", button: "#27ae60", text: "#2c2c2c" },
  MEELZ: { primary: "#c9a96e", secondary: "#2c2c54", background: "#faf7f2", header: "#1a1a2e", footer: "#0d0d1a", button: "#c9a96e", text: "#2c2c54" },
  DEMO:  { primary: "#ff6b35", secondary: "#2ecc71", background: "#ffffff", header: "#1a1a2e", footer: "#1a1a2e", button: "#ff6b35", text: "#333333" },
};

const ADMIN_LAYOUT_DEFAULT  = { headerStyle: "sticky", footerLayout: "simple",   navStyle: "horizontal", containerWidth: "1200px" };
const CLIENT_LAYOUT_DEFAULT = { headerStyle: "sticky", footerLayout: "detailed", heroStyle: "full-width", navStyle: "horizontal", containerWidth: "1200px" };

export const getBrandDefaults = () => {
  const code = projectCode || "CK";
  return {
    adminConfig:  { logo: null, colors: BRAND_ADMIN_COLORS[code]  || BRAND_ADMIN_COLORS.CK,  layout: ADMIN_LAYOUT_DEFAULT  },
    clientConfig: { logo: null, colors: BRAND_CLIENT_COLORS[code] || BRAND_CLIENT_COLORS.CK, layout: CLIENT_LAYOUT_DEFAULT },
  };
};